import * as React from 'react';
import { observer } from 'mobx-react';
import { FormState, FieldState } from 'formstate';
import { locationStore, languageStore, LocationInterface, equipmentStore, EquipmentInterface, userStore } from 'stores';
import TableHeader from 'components/Table/TableHeader';
import { required } from 'helpers/FormValidation';
import DetailsPage from '../DetailsPage';
import * as _ from 'lodash';
import { ModalColumn } from 'components/Modal';
import ContractDetailsItem from 'components/ContractDetailsItem';
import Location from 'components/Forms/Location';

@observer class EquipmentPage extends React.Component {

    form = new FormState({
        id: new FieldState<null | string>(null),
        name: new FieldState(null).validators(required),
        locationId: new FieldState(null).validators(required)
    })

    componentDidMount() {
        const companyId = userStore.signedInUser.company.id;
        locationStore.getLocationsByCompany(companyId);

        equipmentStore.getAllEquipment();
    }

    onDeleteEquipment = async (id: string) => {
        const eq = _.find(equipmentStore.allEquipment, { id: id }) as EquipmentInterface;
        const locationId = eq.locationId;

        await equipmentStore.deleteEquipment(locationId, id);
    }

    render() {
        const data = equipmentStore.allEquipment || [];
        const locations = locationStore.locations || [];
        const form = this.form.$;
        const isNewEntity = !!!form.id.$;

        const columns = [
            {
                Header: <TableHeader value={languageStore.get('name')} />,
                accessor: 'name'
            },
            {
                Header: <TableHeader value={languageStore.get('location')} />,
                id: 'locationId',
                accessor: (d: any) => {
                    const loc = _.find(locations, { id: d.locationId }) as LocationInterface;
                    return loc ? loc.name : '-';
                }
            },
        ]

        return (
            <DetailsPage
                fullWidth={true}
                generalTitle={languageStore.get('equipment')}
                modalTitle={languageStore.get('equipment')}
                form={this.form}
                onUpdate={(eq: EquipmentInterface) => equipmentStore.updateEquipment(eq)}
                onSubmit={(eq: EquipmentInterface) => equipmentStore.createEquipment(eq)}
                onDelete={(id: string) => this.onDeleteEquipment(id)}
                collection={data}
                columns={columns}>

                <ModalColumn>

                    <ContractDetailsItem
                        fieldState={form.name}
                        label={languageStore.get('name')}
                        id='name'
                        editMode={true} />

                    {
                        isNewEntity &&
                        <Location fieldState={form.locationId} editMode={true} />
                    }

                </ModalColumn>

            </DetailsPage>
        )
    }

}

export default EquipmentPage;